Postlogin.Lesson = (function (my) {
    my.Memory = function () {
        const me = Postlogin.Lesson.Segment.apply(this, arguments);

        me.play_pause_enabled = false;

        let container;
        const containerId = `${me.activity_type}-container-${me.segment_index}`;
        let cards;
        const numberOfOptions = Object.keys(me.options).length;
        let numberMatched = 0;

        let selectedOption = null;
        let paused = false;

        me.init = function () {
            if (me.activity_data.instructions) {
                me.help_enabled = true;
            }
            me.renderSegment();
        };

        me.renderSegment = function () {
            container = me.renderSegmentContainer();
            const segmentContainer = $('<div></div>')
                .addClass(`${me.activity_type}-container segment-content-container`)
                .attr('id', containerId);

            // set the number of options (used in css for displaying options)
            segmentContainer.attr('data-options-count', numberOfOptions);

            // add the options
            const table = $('<div></div>').addClass('table');

            $.each(me.options, (optionId, option) => {
                const optionItem = $('<div></div>').addClass(`item option-${optionId}`).attr('data-option-id', optionId);
                const wrapper = $('<div></div>').addClass('wrapper');
                const back = $('<div></div>').addClass('back');
                const front = $('<div></div>').addClass('front');
                if (option.answer_image) {
                    optionItem.addClass('has-image');
                    front.css('backgroundImage', `url(${option.answer_image})`);
                    if (option.answer) {
                        front.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                    }
                } else {
                    optionItem.addClass('text-only');
                    if (option.answer) {
                        front.append(`<div class="option-text"><span>${option.answer}</span></div>`);
                    }
                }
                wrapper.append(front);
                wrapper.append(back);
                optionItem.append(wrapper);

                optionItem.on('click', function () {
                    if ($(this).hasClass('matched')) {
                        return;
                    }

                    if ($(this).hasClass('flipped')) {
                        return;
                    }

                    if (paused) {
                        return;
                    }

                    const optId = $(this).attr('data-option-id');
                    Postlogin.Lesson.playSoundEffect('flip');

                    paused = true;
                    $(this).addClass('flipped');
                    $(this).one(Jr.getTransitionEndEvent(), () => {
                        if (selectedOption == null) {
                            selectedOption = optId;
                            paused = false;
                        } else if (selectedOption === optId) {
                            setTimeout(() => {
                                $(container).find('.flipped').removeClass('flipped').addClass('matched animated tada');
                                Postlogin.Lesson.playSoundEffect('correct');
                                selectedOption = null;
                                setTimeout(() => {
                                    $(cards).removeClass('animated tada');
                                    numberMatched++;

                                    const feedbackTitle = me.options[optId].feedback_title;
                                    const feedbackAudio = me.options[optId].feedback_audio;
                                    const feedbackBody = me.getOptionFeedback(optId);

                                    if (feedbackBody) {
                                        $('#beep-9-modal .content-container').addClass('correct');

                                        // show the option-feedback modal window
                                        Postlogin.Lesson.Popup.showModal({
                                            title: feedbackTitle,
                                            body: feedbackBody,
                                            class: 'correct',
                                            overlay: 'light',
                                            smaller: true,
                                            actions: [
                                                {
                                                    label: 'Continue',
                                                    cssClass: 'btn-xl btn-success btn-continue',
                                                    onClick(e) {
                                                        e.stopPropagation();
                                                        Postlogin.Lesson.pauseCurrentSound();
                                                        if (numberOfOptions === numberMatched) {
                                                            Postlogin.Lesson.Popup.showCompletionModal(me);
                                                        } else {
                                                            Postlogin.Lesson.Popup.hideModal();
                                                        }
                                                    },
                                                },
                                                {
                                                    label: 'Replay <i class="fa fa-volume-up"></i>',
                                                    cssClass: 'btn-replay-audio btn-default pull-left',
                                                    onClick(e) {
                                                        e.stopPropagation();
                                                        $(this).fadeOut();
                                                        Postlogin.Lesson.playSound(feedbackAudio, 0, null, () => {
                                                            $('#beep-9-modal .btn-replay-audio').fadeIn();
                                                        });
                                                    },
                                                },
                                            ],
                                            onShow() {
                                                $('#beep-9-modal .btn-replay-audio').fadeOut();
                                                if (feedbackAudio) {
                                                    if (
                                                        Postlogin.Lesson.soundEnabled()
                                                        && !$(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).hasClass(
                                                            `dont-disable-feedback-${optId}continue`,
                                                        )
                                                    ) {
                                                        $('#beep-9-modal .btn-continue').prop('disabled', true);
                                                    }
                                                    Postlogin.Lesson.playSound(feedbackAudio, 500, null, () => {
                                                        $('#beep-9-modal .btn-replay-audio').fadeIn();
                                                        $('#beep-9-modal .btn-continue').prop('disabled', false);
                                                        $(`#segment-${Postlogin.Lesson.getCurrentSegmentIndex()}`).addClass(
                                                            `dont-disable-feedback-${optId}continue`,
                                                        );
                                                    });
                                                }
                                            },
                                            onHide() {
                                                $('#beep-9-modal .content-container').removeClass('correct');
                                                paused = false;
                                            },
                                        });
                                    } else {
                                        paused = false;
                                        Postlogin.Lesson.pauseCurrentSound();

                                        if (feedbackAudio) {
                                            Postlogin.Lesson.playSound(feedbackAudio, 500);
                                        }

                                        if (numberOfOptions === numberMatched) {
                                            setTimeout(() => {
                                                Postlogin.Lesson.Popup.showCompletionModal(me);
                                            }, 750);
                                        }
                                    }
                                }, 500);
                            }, 500);
                        } else {
                            selectedOption = null;
                            cards = $(container).find('.flipped');

                            setTimeout(() => {
                                $(cards).addClass('incorrect animated shake');
                                Postlogin.Lesson.playSoundEffect('incorrect');
                                setTimeout(() => {
                                    $(cards).removeClass(' flipped');

                                    setTimeout(() => {
                                        $(cards).removeClass('incorrect animated shake');
                                        paused = false;
                                    }, 500);
                                }, 750);
                            }, 750);
                        }
                    });
                });

                const items = table.find('.item');
                if (me.activity_data.shuffled && items.length) {
                    if (Math.floor(Math.random() * 2)) {
                        items.eq(Math.floor(Math.random() * items.length)).after(optionItem);
                    } else {
                        items.eq(Math.floor(Math.random() * items.length)).before(optionItem);
                    }
                } else {
                    table.append(optionItem);
                }

                const optionItemCopy = optionItem.clone(true);
                // add the 2nd copy of the item
                if (me.activity_data.shuffled && items.length) {
                    if (Math.floor(Math.random() * 2)) {
                        items.eq(Math.floor(Math.random() * items.length)).after(optionItemCopy);
                    } else {
                        items.eq(Math.floor(Math.random() * items.length)).before(optionItemCopy);
                    }
                } else {
                    table.append(optionItemCopy);
                }
            });

            segmentContainer.append(table);
            container.find('.aspect-wrapper').append(segmentContainer);

            // add this segment container to the page
            $('#page-container').append(container);
        };

        me.replay = function (forceShowHelp = false) {
            numberMatched = 0;

            $(container)
                .find('.item')
                .each(function () {
                    $(this).removeClass('matched flipped correct incorrect');
                });

            Postlogin.Lesson.hideNextButton();

            // show the help popup
            Postlogin.Lesson.Popup.showHelp(
                me,
                () => {
                    me.speakQuestion(500, () => {
                        const delay = 50;
                        $(container)
                            .find('.item')
                            .each((i, item) => {
                                setTimeout(() => {
                                    $(item).toggleClass('flipped');
                                }, delay * i);
                            });
                        setTimeout(() => {
                            $(container)
                                .find('.item')
                                .each((i, item) => {
                                    setTimeout(() => {
                                        $(item).toggleClass('flipped');
                                    }, delay * i);
                                });
                        }, numberOfOptions * 2 * delay + delay * 30);

                        if (me.completed && !me.last) {
                            Postlogin.Lesson.showNextButton();
                        }
                    });
                },
                forceShowHelp,
            );
        };

        me.show = function () {
            me.setup();
            me.replay();
        };

        me.hide = function () {
            me.breakdown();
        };

        me.checkCompletion = function () {
            if (numberOfOptions === numberMatched) {
                setTimeout(() => {
                    Postlogin.Lesson.Popup.showCompletionModal(me);
                }, 750);
            }
        };

        return me;
    };

    return my;
}(Postlogin.Lesson || {}));
